import React from "react";
import styled from "styled-components";
import isJFK from "utils/helperFunctions";

const isRounded = isJFK();

function Button(props) {
  return (
    <CustomButton
      {...props}
      style={props.style}
      onClick={props.onClick}
      disabled={props.disabled}
      width={props.width}
      height={props.height}
      className={props.className}
    >
      {props.children}
    </CustomButton>
  );
}

export const CustomButton = styled.button`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "100%"};
  background-color: ${({ backgroundColor }) =>
    backgroundColor || "var(--primary)"};
  color: ${({ color }) => color || "var(--primary-foreground)"};
  outline: none;
  cursor: default;
  margin: 0;
  padding: 0;
  border: none;

  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;
  }

  border-radius: ${(props) => (isRounded ? "100px" : "8px")};
`;

export default Button;
